<template>
	<v-container class="content" fluid>
		<v-layout column>
			<v-flex>
				<v-snackbar
					v-model="snackbar"
					:timeout="10000"
					:top="true"
					color="accent"
					class="black--text"
				>
					{{ snackbarText }}
					<v-btn class="blexon-button" small icon @click="snackbar = false">
						<v-icon>close</v-icon>
					</v-btn>
				</v-snackbar>
			</v-flex>
			<v-flex xs12>
				<h1 class="display-1">Leergut vom Transporteur</h1>
			</v-flex>
			<v-flex xs12 mb-3>
				<v-btn @click="createNewLeergutReturn()" class="blexon-button">
					Neue Rücklieferung erfassen
				</v-btn>
			</v-flex>
			<v-flex xs12 v-if="!summary && isLoading" text-center>
				<v-progress-circular color="accent" indeterminate></v-progress-circular>
			</v-flex>
			<v-flex xs12 v-if="summary">
				<v-data-table
					:headers="returnHeaders"
					:items="summary.returns"
					:loading="isLoading"
					item-key="id"
					hide-actions
					class="elevation-1"
				>
					<v-progress-linear
						slot="progress"
						color="accent"
						indeterminate
					></v-progress-linear>
					<template slot="items" slot-scope="props">
						<tr
							@click="
								() => {
									props.expanded = !props.expanded;
									expandReturn(props.item.id);
								}
							"
						>
							<td v-if="props.item.id != 0" class="text-xs-left">
								{{ props.item.returnDate | formatDate }}
							</td>
							<td v-else></td>
							<td v-if="props.item.id != 0" class="text-xs-left">
								{{ getProviderName(props.item.transportProviderId) }}
							</td>
							<td v-else></td>
							<td v-if="props.item.id != 0" class="text-xs-left">
								<span title="Saldo nach letzter Rücklieferung plus Auslieferungen"
									>Saldo vorher:
									{{ props.item.palletCount + props.item.newPalletSaldo }}<br
								/></span>
								<span title="Vom LKW-Fahrer an Abholstelle"
									>Rücklieferung: {{ props.item.palletCount }}<br
								/></span>
								<span v-if="props.item.newPalletSaldo > 0"
									>Saldo nachher: {{ props.item.newPalletSaldo }}</span
								>
							</td>
							<td v-else></td>
							<td v-if="props.item.id != 0" class="text-xs-left">
								<span title="Saldo nach letzter Rücklieferung plus Auslieferungen"
									>Saldo vorher:
									{{ props.item.frameCount + props.item.newFrameSaldo }}<br
								/></span>
								<span title="Vom LKW-Fahrer an Abholstelle"
									>Rücklieferung: {{ props.item.frameCount }}<br
								/></span>
								<span v-if="props.item.newFrameSaldo > 0"
									>Saldo nachher: {{ props.item.newFrameSaldo }}</span
								>
							</td>
							<td v-else></td>
							<td v-if="props.item.id != 0" class="text-xs-left">
								<span title="Saldo nach letzter Rücklieferung plus Auslieferungen"
									>Saldo vorher: {{ props.item.lidCount + props.item.newLidSaldo
									}}<br
								/></span>
								<span title="Vom LKW-Fahrer an Abholstelle"
									>Rücklieferung: {{ props.item.lidCount }}<br
								/></span>
								<span v-if="props.item.newLidSaldo > 0"
									>Saldo nachher: {{ props.item.newLidSaldo }}</span
								>
							</td>
							<td v-else></td>
							<td v-if="props.item.id != 0" class="text-xs-left">
								{{ props.item.newSaldoManuallyOverridden ? "Ja" : "Nein" }}
							</td>
							<td v-else></td>
							<td class="text-xs-left" style="min-width: 300px">
								{{ props.item.note }}
							</td>
							<td class="text-xs-left">
								<v-btn
									v-if="isAdmin"
									@click.stop="downloadExcelReport(props.item.id)"
									:disabled="isLoadingReport"
									small
									class="blexon-button"
									title="Excel Report erstellen"
								>
									<v-progress-circular
										size="16"
										v-if="isLoadingReport"
										indeterminate
									></v-progress-circular>
									<v-icon>table_view</v-icon>
								</v-btn>
								<v-btn
									v-if="props.item.id != 0 && isLatestReturn(props.item.id)"
									small
									class="blexon-button"
									title="Rücksendung bearbeiten"
									:disable="isLoading || isLoadingDeliveries || isLoadingReport"
									@click.stop="editLeergutReturn(props.item.id)"
								>
									<v-icon>edit</v-icon>
								</v-btn>
							</td>
						</tr>
					</template>
					<template slot="expand" slot-scope="props">
						<div class="mx-2">
							<v-data-table
								:headers="leergutHeaders"
								:items="getFilteredDeliveries(props.item.id)"
								:loading="isLoadingDeliveries"
								item-key="shippingId"
								hide-actions
							>
								<v-progress-linear
									slot="progress"
									color="accent"
									indeterminate
								></v-progress-linear>
								<template slot="items" slot-scope="deli">
									<tr style="border-left: 20px solid grey">
										<td class="text-xs-left">{{ deli.item.orderId }}</td>
										<td class="text-xs-left">
											{{ getProviderName(deli.item.transportProviderId) }}
										</td>
										<td class="text-xs-left">{{ deli.item.sendungsnummer }}</td>
										<td class="text-xs-left">
											{{ deli.item.deliveryDate | formatDate }}
										</td>
										<td class="text-xs-left">{{ deli.item.palletCount }}</td>
										<td class="text-xs-left">{{ deli.item.frameCount }}</td>
										<td class="text-xs-left">{{ deli.item.lidCount }}</td>
									</tr>
								</template>
							</v-data-table>
						</div>
					</template>
					<template slot="no-data"> Keine Lieferungen vorhanden </template>
				</v-data-table>
			</v-flex>
			<v-flex xs12 v-if="summary">
				<v-card>
					<v-card-text style="padding-left: 24px">
						<b>Aktuelle Saldi:</b><br />
						<span style="display: block; margin-left: 12px"
							>Paletten: {{ getCurrentSaldos.pallet }}</span
						>
						<span style="display: block; margin-left: 12px"
							>Rahmen: {{ getCurrentSaldos.frame }}</span
						>
						<span style="display: block; margin-left: 12px"
							>Deckel: {{ getCurrentSaldos.lid }}</span
						>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>

		<v-dialog v-model="leergutReturnDialog" persistent width="500">
			<v-form ref="form" v-model="formValid">
				<v-card>
					<v-card-title class="headline grey lighten-2" primary-title>
						Leergut Rücklieferung erfassen
					</v-card-title>
					<v-card-text>
						<!-- Datum -->
						<v-layout row ma-0>
							<v-flex xs12>
								<date-picker
									:selectedDate="leergutReturnDateString"
									:disabled="leergutReturnDto.id > 0"
									label="Datum der Rücklieferung"
									v-on:updateSelectedDate="updateReturnDate($event)"
								>
								</date-picker>
							</v-flex>
						</v-layout>
						<!-- Counts -->
						<v-layout row align-center ma-0>
							<v-flex xs4 pr-2>
								<v-text-field
									v-model="leergutReturnDto.palletCount"
									@keyup="refreshNewSaldos()"
									label="Paletten erhalten"
									:rules="positiveIntegerRule"
								></v-text-field>
							</v-flex>
							<v-flex xs4 pr-2>
								<v-text-field
									v-model="leergutReturnDto.frameCount"
									@keyup="refreshNewSaldos()"
									label="Rahmen erhalten"
									:rules="positiveIntegerRule"
								></v-text-field>
							</v-flex>
							<v-flex xs4>
								<v-text-field
									v-model="leergutReturnDto.lidCount"
									@keyup="refreshNewSaldos()"
									label="Deckel erhalten"
									:rules="positiveIntegerRule"
								></v-text-field>
							</v-flex>
						</v-layout>
						<!-- Override -->
						<v-layout row ma-0 v-if="isAdmin">
							<v-flex xs12>
								<v-checkbox
									v-model="leergutReturnDto.newSaldoManuallyOverridden"
									label="Neue Saldos manuell eintragen"
									hide-details
								></v-checkbox>
							</v-flex>
						</v-layout>
						<!-- Saldos -->
						<v-layout row align-center ma-0 v-if="isAdmin">
							<v-flex xs4 pr-2>
								<v-text-field
									v-model="leergutReturnDto.newPalletSaldo"
									:disabled="!leergutReturnDto.newSaldoManuallyOverridden"
									label="Saldo Paletten"
									:rules="integerRule"
								></v-text-field>
							</v-flex>
							<v-flex xs4 pr-2>
								<v-text-field
									v-model="leergutReturnDto.newFrameSaldo"
									:disabled="!leergutReturnDto.newSaldoManuallyOverridden"
									label="Saldo Rahmen"
									:rules="integerRule"
								></v-text-field>
							</v-flex>
							<v-flex xs4>
								<v-text-field
									v-model="leergutReturnDto.newLidSaldo"
									:disabled="!leergutReturnDto.newSaldoManuallyOverridden"
									label="Saldo Deckel"
									:rules="integerRule"
								></v-text-field>
							</v-flex>
						</v-layout>
						<!-- Bemerkung -->
						<v-layout row ma-0>
							<v-flex xs12>
								<v-textarea
									v-model="leergutReturnDto.note"
									label="Bemerkung"
								></v-textarea>
							</v-flex>
						</v-layout>
						<!-- Error -->
						<v-layout row ma-0 v-if="!newDateIsValid">
							<v-flex v-if="!newDateIsValid" xs12 class="error--text">
								Es gibt bereits neuere Rücklieferungen.
							</v-flex>
						</v-layout>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn @click="leergutReturnDialog = false" flat> Abbrechen </v-btn>
						<v-btn
							@click="saveLeergutReturnAndReload()"
							:disabled="isLoading || !formValid || !newDateIsValid"
							class="blexon-button"
							flat
						>
							Speichern
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>
	</v-container>
</template>
<script>
import httpClient from "../store/httpClient";
import moment from "moment";
import DatePicker from "./datePicker.vue";
import Rules from "../store/rules.js";

export default {
	components: {
		"date-picker": DatePicker,
	},
	data() {
		return {
			isLoading: false,
			isLoadingDeliveries: false,
			isLoadingReport: false,
			snackbar: false,
			snackbarText: "",
			summary: null,
			leergutReturnDialog: false,
			leergutReturnDto: {},
			leergutReturnDateString: moment().format("YYYY-MM-DD"),
			formValid: true,
			currentTransportProviderId: -1,
			returnHeaders: [
				{
					value: "deliveryDate",
					text: "Rückgabe vom",
					sortable: false,
					width: "1%",
				},
				{
					value: "transportProvider",
					text: "Transporteur",
					sortable: false,
					width: "1%",
				},
				{
					value: "pallet",
					text: "Paletten",
					sortable: false,
					width: "100px",
				},
				{
					value: "frames",
					text: "Rahmen",
					sortable: false,
					width: "100px",
				},
				{
					value: "lids",
					text: "Deckel",
					sortable: false,
					width: "100px",
				},
				{
					value: "override",
					text: "Manueller Saldo",
					sortable: false,
					width: "1%",
				},
				{
					value: "note",
					text: "Bemerkung",
					sortable: false,
					width: "10%",
				},
				{
					value: "actions",
					text: "",
					sortable: false,
					width: "1%",
				},
			],
			leergutHeaders: [
				{
					value: "orderId",
					text: "Auftragsnummer",
					sortable: false,
					width: "1%",
				},
				{
					value: "transportProvider",
					text: "Transporteur",
					sortable: false,
					width: "1%",
				},
				{
					value: "deliveryNumber",
					text: "Sendungsnummer",
					sortable: false,
					width: "1%",
				},
				{
					value: "deliveryDate",
					text: "Lieferdatum",
					sortable: false,
					width: "1%",
				},
				{
					value: "pallet",
					text: "Paletten",
					sortable: false,
					width: "1%",
				},
				{
					value: "frames",
					text: "Rahmen",
					sortable: false,
					width: "1%",
				},
				{
					value: "lids",
					text: "Deckel",
					sortable: false,
					width: "1%",
				},
			],
			positiveIntegerRule: Rules.requiredPositiveIntegerRule,
			integerRule: Rules.requiredIntegerRule,
		};
	},

	async mounted() {
		await this.getLeergutWithSaldo();
	},

	computed: {
		isAdmin() {
			return this.$store.getters.currentFertiger(this.$route.params.fertigerId)
				.canManuallyTransmit;
		},
		transportProviders() {
			return this.$store.state.transportProviders;
		},
		newDateIsValid() {
			if (!this.leergutReturnDto || this.leergutReturnDto.id > 0) return true;
			let newDate = new Date(this.leergutReturnDto.returnDate);
			let latestDate = new Date(this.dateOfLatestReturn);
			newDate.setHours(0, 0, 0, 0);
			latestDate.setHours(0, 0, 0, 0);
			return newDate >= latestDate;
		},
		dateOfLatestReturn() {
			if (!this.summary) return new Date();
			return this.summary.returns[this.summary.returns.length - 1].returnDate;
		},
		dateOfSecondLatestReturn() {
			if (!this.summary) return new Date();
			return this.summary.returns[this.summary.returns.length - 2].returnDate;
		},
		getLatestSaldos() {
			let latestReturn = this.summary.returns[this.summary.returns.length - 1];
			let saldos = {
				pallet: latestReturn.newPalletSaldo,
				frame: latestReturn.newFrameSaldo,
				lid: latestReturn.newLidSaldo,
			};
			return saldos;
		},
		getSecondLatestSaldos() {
			let secondLatestReturn = this.summary.returns[this.summary.returns.length - 2];
			let saldos = {
				pallet: secondLatestReturn.newPalletSaldo,
				frame: secondLatestReturn.newFrameSaldo,
				lid: secondLatestReturn.newLidSaldo,
			};
			return saldos;
		},
		getCurrentSaldos() {
			let relevantDeliveries = this.summary.deliveries.filter((d) => {
				let deliveryDate = new Date(d.deliveryDate);
				deliveryDate.setHours(0, 0, 0, 0);
				let currentDate = new Date();
				currentDate.setHours(0, 0, 0, 0);
				let dateOfLatestReturn = new Date(this.dateOfLatestReturn);
				dateOfLatestReturn.setHours(0, 0, 0, 0);
				return deliveryDate > dateOfLatestReturn && deliveryDate <= currentDate;
			});
			let palletSum = relevantDeliveries.reduce(
				(sum, delivery) => sum + delivery.palletCount,
				0
			);
			let frameSum = relevantDeliveries.reduce(
				(sum, delivery) => sum + delivery.frameCount,
				0
			);
			let lidSum = relevantDeliveries.reduce((sum, delivery) => sum + delivery.lidCount, 0);
			let latestSaldos = this.getLatestSaldos;
			let saldos = {
				pallet: latestSaldos.pallet + palletSum,
				frame: latestSaldos.frame + frameSum,
				lid: latestSaldos.lid + lidSum,
			};
			return saldos;
		},
	},

	methods: {
		editLeergutReturn(returnId) {
			this.leergutReturnDto = JSON.parse(
				JSON.stringify(this.summary.returns.find((r) => r.id === returnId))
			);
			this.leergutReturnDateString = moment(this.leergutReturnDto.returnDate).format(
				"YYYY-MM-DD"
			);
			this.leergutReturnDialog = true;
		},
		createNewLeergutReturn() {
			this.resetNewLeergutReturnDto();
			this.leergutReturnDateString = moment().format("YYYY-MM-DD");
			this.refreshNewSaldos();
			this.leergutReturnDialog = true;
		},
		isLatestReturn(returnId) {
			let returnIndex = this.summary.returns.findIndex((r) => r.id === returnId);
			return returnIndex === this.summary.returns.length - 1;
		},
		updateReturnDate(date) {
			this.leergutReturnDateString = moment(date).format("YYYY-MM-DD");
			this.leergutReturnDto.returnDate = new Date(date);
			this.refreshNewSaldos();
		},
		getProviderName(providerId) {
			return this.transportProviders.find((p) => p.id === providerId)
				? this.transportProviders.find((p) => p.id === providerId).name
				: "N/A";
		},
		getFilteredDeliveries(returnId) {
			let returnIndex = this.summary.returns.findIndex((r) => r.id === returnId);
			let startDate = new Date(this.summary.returns[returnIndex].returnDate);
			let stopDate = this.getDateOfNextReturn(returnId);
			return this.summary.deliveries.filter((d) => {
				let date = new Date(d.deliveryDate);
				date.setHours(0, 0, 0, 0);
				startDate.setHours(0, 0, 0, 0);
				stopDate.setHours(0, 0, 0, 0);
				return date > startDate && date <= stopDate;
			});
		},
		expandReturn(returnId) {
			let leergutReturn = this.summary.returns.find((r) => r.id === returnId);
			if (!leergutReturn.deliveriesLoaded) {
				this.getDeliveries(returnId);
				leergutReturn.deliveriesLoaded = true;
			}
		},
		getDateOfNextReturn(returnId) {
			let returnIndex = this.summary.returns.findIndex((r) => r.id === returnId);
			let date = new Date(); // If there is no next return, take current date
			if (this.summary.returns.length > returnIndex + 1) {
				let nextReturn = this.summary.returns[returnIndex + 1];
				date = new Date(nextReturn.returnDate);
			}
			return date;
		},
		resetNewLeergutReturnDto() {
			this.leergutReturnDto = {
				id: 0,
				returnDate: new Date(),
				palletCount: 0,
				frameCount: 0,
				lidCount: 0,
				newPalletSaldo: 0,
				newFrameSaldo: 0,
				newLidSaldo: 0,
				newSaldoManuallyOverridden: false,
				note: "",
			};
		},
		refreshNewSaldos() {
			if (this.leergutReturnDto.newSaldoManuallyOverridden) return;
			let isEdit = this.leergutReturnDto.id != 0;
			let relevantDeliveries = this.summary.deliveries.filter((d) => {
				let deliveryDate = new Date(d.deliveryDate);
				deliveryDate.setHours(0, 0, 0, 0);
				let newReturnDate = new Date(this.leergutReturnDto.returnDate);
				newReturnDate.setHours(0, 0, 0, 0);
				let dateOfLatestReturn = isEdit
					? new Date(this.dateOfSecondLatestReturn)
					: new Date(this.dateOfLatestReturn);
				dateOfLatestReturn.setHours(0, 0, 0, 0);
				return deliveryDate > dateOfLatestReturn && deliveryDate <= newReturnDate;
			});
			let palletSum = relevantDeliveries.reduce(
				(sum, delivery) => sum + delivery.palletCount,
				0
			);
			let frameSum = relevantDeliveries.reduce(
				(sum, delivery) => sum + delivery.frameCount,
				0
			);
			let lidSum = relevantDeliveries.reduce((sum, delivery) => sum + delivery.lidCount, 0);
			let latestSaldos = isEdit ? this.getSecondLatestSaldos : this.getLatestSaldos;

			this.leergutReturnDto.newPalletSaldo =
				latestSaldos.pallet + palletSum - this.leergutReturnDto.palletCount;
			this.leergutReturnDto.newFrameSaldo =
				latestSaldos.frame + frameSum - this.leergutReturnDto.frameCount;
			this.leergutReturnDto.newLidSaldo =
				latestSaldos.lid + lidSum - this.leergutReturnDto.lidCount;
		},
		async getLeergutWithSaldo() {
			if (this.isLoading) return;
			try {
				this.isLoading = true;
				let response = await httpClient().get(
					`api/Leergut/GetLeergutWithSaldo?fertigerId=${this.$route.params.fertigerId}`
				);
				this.summary = response.data;
				this.currentTransportProviderId = this.summary.returns[0].transportProviderId;
				this.summary.returns.forEach((r) => (r.deliveriesLoaded = false));
				this.summary.returns[this.summary.returns.length - 1].deliveriesLoaded = true;
			} catch (err) {
				console.log(err);
			} finally {
				this.isLoading = false;
			}
		},
		async getDeliveries(returnId) {
			console.log("loading deliveries");
			try {
				this.isLoadingDeliveries = true;
				let startDate = new Date(
					this.summary.returns.find((r) => r.id === returnId).returnDate
				);
				let stopDate = this.getDateOfNextReturn(returnId);
				let response = await httpClient().get(
					`api/Leergut/GetDeliveries?fertigerId=${this.$route.params.fertigerId}` +
						`&from=${startDate.toJSON()}&to=${stopDate.toJSON()}`
				);
				response.data.forEach((x) => this.summary.deliveries.push(x));
			} catch (err) {
				console.log(err);
			} finally {
				this.isLoadingDeliveries = false;
			}
		},
		async saveLeergutReturnAndReload() {
			await this.saveLeergutReturn();
			await this.getLeergutWithSaldo();
		},
		async saveLeergutReturn() {
			try {
				this.isLoading = true;
				this.leergutReturnDto.fertigerId = parseInt(this.$route.params.fertigerId);
				this.leergutReturnDto.transportProviderId = this.currentTransportProviderId;
				await httpClient().post(
					"api/Leergut/CreateOrUpdateLeergutReturn",
					this.leergutReturnDto
				);
				this.leergutReturnDialog = false;
			} catch (err) {
				console.log(err);
				this.setSnackbarText("Rücklieferung konnte nicht gespeichert werden.");
			} finally {
				this.isLoading = false;
			}
		},
		async downloadExcelReport(returnId) {
			try {
				this.isLoadingReport = true;
				var response = await httpClient().post(
					`api/Leergut/DownloadLeergutExcelReport?` +
						`fertigerId=${this.$route.params.fertigerId}&returnId=${returnId}`,
					null,
					{
						responseType: "blob",
					}
				);
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "Leergut_Report.xlsx");
				link.click();
			} catch (err) {
				this.setSnackbarText("Fehler beim Download des Excel Reports.");
			} finally {
				this.isLoadingReport = false;
			}
		},
		setSnackbarText(text) {
			this.snackbarText = text;
			this.snackbar = true;
		},
	},
};
</script>
<style>
.v-input--selection-controls {
	margin: 0px;
}
.v-label {
	margin-bottom: 0px !important;
}
</style>
